
const getters = {
    venue: state => state.venue.venue,
    venueId: state => state.venue.venue.id || '',
    readerId: state => state.user.user.id,
    userName: state => state.user.user.nickname,
    user: state => state.user.user,
    visibleLogin: state => state.user.visibleLogin,
    menuId: state => state.user.menuId,
    includeArr: state => state.user.includeArr,
    pNumber: state => state.user.pNumber,
}
export default getters